import "./BlendUniformity.module.css";
import Header from "@/reusable_sections/Header";
import BlendUniformity from "./sections/BlendUniformity";
import BlendRisks from "./sections/BlendRisks";
import Workflow from "./sections/Workflow";
import Systems from "./sections/Systems";
import ProcessTimeline from "./sections/ProcessTimeline";
import Solutions from "./sections/Solutions";
import BlendBanner from "./sections/BlendBanner";
import Footer from "@/reusable_sections/Footer";
export default function BlendUniformityPage() {
  return <div>
      <Header />
      <BlendUniformity />
      <BlendRisks />
      <Workflow />
      <Systems />
      <ProcessTimeline />
      <Solutions />
      <BlendBanner />
      <Footer />
    </div>;
}